import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 15000
})

service.interceptors.request.use(config => {
  const token = store.getters.token
  if (token) config.headers['Authorization'] = 'Bearer ' + token
  return config
})

service.interceptors.response.use(
  res => {
    const data = res.data
    if (data.code === 1201 || data.code === 1203) {
      store.dispatch('user/resetToken')
      if (router.currentRoute.path !== '/login') {
        router.push('/login').catch(() => {})
      }
      return Promise.reject(new Error(data.msg || '请先登录'))
    }
    if (data.code !== 1) {
      Message.error(data.msg || '请求失败')
      return Promise.reject(new Error(data.msg))
    }
    return data
  },
  err => {
    Message.error(err.message || '网络错误')
    return Promise.reject(err)
  }
)

export default service
